import { useContext } from 'react';
import { MenuContext } from '../../context/MenuContext';
import { FileDownloadsContext } from '../../context/FileDownloadsContext';
import 'primereact/resources/themes/lara-light-cyan/theme.css';

const FileDownloadsPane = () => {
    const { selectedMenuItem } = useContext(MenuContext);
    const { selectedFileDownload } = useContext(FileDownloadsContext);

    const PageComponent = selectedFileDownload?.pageComponent;

    if (!PageComponent) {
        return <div>File download page not found</div>;
    }

    return (
        <div className="bg-white rounded-md shadow-md m-4 p-6">
            <h1 className="text-xl font-bold mb-4">{selectedMenuItem.name}</h1>
            <PageComponent />
        </div>
    );
};

export default FileDownloadsPane;
